import { render, staticRenderFns } from "./UserLogDetails.vue?vue&type=template&id=637f0418&"
import script from "./UserLogDetails.vue?vue&type=script&lang=js&"
export * from "./UserLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports